document.querySelectorAll( '.blurb, .card' ).forEach( el => {
    el.addEventListener( 'mouseover', e => {
        el.classList.add( 'animated', 'pulse' );
    } );
    el.addEventListener( 'mouseout', e => {
        el.classList.remove( 'animated', 'pulse' );
    } );
} );
if ( document.getElementById( 'slogan' ) ) {
    $( '#slogan' ).owlCarousel( {
        loop: true,
        autoplay: true,
        nav: false,
        center: true,
        autoplaySpeed: 100,
        animateIn: 'flipInX',
        animateOut: 'flipOutX',
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    } );
}